import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Copy, Link2, Link2Off } from "lucide-react";
import { API, api, formatApiError } from "@/lib/api";

export function BriefLink() {
  const [key, setKey] = useState<string | null | undefined>(undefined);
  useEffect(() => { api.get("/admin/brief-link").then((r) => setKey(r.data.key)).catch(() => setKey(null)); }, []);
  const url = key ? `${API}/brief/${key}` : "";
  const call = async (method: "post" | "delete") => {
    try { const { data } = await api[method]("/admin/brief-link"); setKey(data.key); toast.success(data.key ? "New private link ready" : "Link switched off"); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  const copy = async () => { await navigator.clipboard.writeText(url); toast.success("Link copied"); };
  if (key === undefined) return null;
  return (
    <div className="paper-card mb-8 p-5" data-testid="brief-link-card">
      <p className="font-display text-lg font-extrabold text-[#23324A]">Printables brief for another AI</p>
      <p className="mt-1 text-sm text-[#23324A]/70">A private, plain web page listing all shop printables with their copy, PDFs and images, readable by any AI. Hidden from Google.</p>
      {key ? (
        <div className="mt-3 flex flex-wrap items-center gap-2">
          <input readOnly value={url} className="min-w-0 flex-1 rounded-xl border-2 border-[#23324A]/20 bg-white px-3 py-2 text-xs" data-testid="brief-link-url" onFocus={(e) => e.target.select()} />
          <button className="btn-outline" onClick={copy} data-testid="brief-link-copy"><Copy className="h-4 w-4" /> Copy</button>
          <a className="btn-outline" href={url} target="_blank" rel="noreferrer" data-testid="brief-link-open">Open</a>
          <button className="btn-ghost" onClick={() => call("post")} data-testid="brief-link-new"><Link2 className="h-4 w-4" /> New link</button>
          <button className="btn-ghost" onClick={() => call("delete")} data-testid="brief-link-off"><Link2Off className="h-4 w-4" /> Switch off</button>
        </div>
      ) : (
        <button className="btn-coral mt-3" onClick={() => call("post")} data-testid="brief-link-create"><Link2 className="h-4 w-4" /> Create private link</button>
      )}
    </div>
  );
}
